export default "/assets/images/spring-background-sm.jpg?9dc529f17dab738f150407fe0f09eea1";